import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../locales/translations';

export function useTexts() {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_CLASSROOM_CALENDAR,
  );
  return {
    classroomDetailBox: {
      classroomName: t('classroomDetailBox.classroomName'),
      code: t('classroomDetailBox.code'),
      classroomType: t('classroomDetailBox.classroomType'),
      school: t('classroomDetailBox.school'),
    },
    reserveClassroomButton: t('reserveClassroomButton'),
    viewCalendar: t('viewCalendar'),
    teachers: t('teachers'),
    form: {
      cardTitle: t('form.cardTitle'),
      cardSubtitle: t('form.cardSubtitle'),
      date: t('form.date'),
      startTime: t('form.startTime'),
      endTime: t('form.endTime'),
      title: t('form.title'),
      description: t('form.description'),
      eventType: t('form.eventType'),
      error: t('form.error'),
      conflictError: t('form.conflictError'),
      modulesError: t('form.modulesError'),
      success: t('form.success'),
      submit: t('form.submit'),
      cancel: t('form.cancel'),
    },
  };
}
